import $ from 'jquery';
import EventBus from '../../common/EventBus';

const SELECTORS = {
  visibleWorkSection: '.js-work-section:not(.hidden)',
  workItemPrice: '.js-work-item-price',
  price: '.js-price',
  priceValue: '.js-price-value',
  dealerPrice: '.js-dealer-price',
  dealerPriceValue: '.js-dealer-price-value',
  priceLoading: '.js-price-loading',
  workItemPriceInline: '.js-work-item-price-inline',
};

const CSS_CLASSES = {
  hidden: 'hidden',
};

export default class QuoteApi {
  constructor() {
    this._subscribeToEvents();
  }

  _subscribeToEvents() {
    EventBus.on('work:section-changed', (data) => {
      this.fetchPrices();
    });
  }

  fetchPrices() {
    const $currentPage = $(SELECTORS.visibleWorkSection);
    const ids = [];
    $currentPage.find(SELECTORS.workItemPrice).each(function (i, item) {
      if ($(item).data('id')) {
        ids.push([$(item).data('id')]);
      }
    });
    if (ids.length === 0 || !$currentPage.find(SELECTORS.price).hasClass(CSS_CLASSES.hidden)) return;

    $.ajax({
      method: 'GET',
      url: '/api/quote.json',
      data: {
        work_item_ids: JSON.stringify(ids),
      },
      success: (data) => this._handleFetchPricesSuccess(data),
      error: () => this._handleFetchPricesError(),
    });
  }

  _handleFetchPricesSuccess(data) {
    Object.keys(data).forEach(function (key) {
      const workItemIds = key
        .replace(/[\[\]]/g, '')
        .split(',')
        .sort()
        .join(',');
      var $currentItem = $(`${SELECTORS.workItemPrice}[data-id="${workItemIds}"]`);
      if (data[key].quote_availability === 'not available') {
        $currentItem.addClass(CSS_CLASSES.hidden);
        return;
      }
      if (data[key].total_price) {
        $currentItem.find(SELECTORS.priceValue).text('£' + parseFloat(data[key].total_price).toFixed(2));
      }
      if (data[key].estimated_dealership_price) {
        $currentItem.find(SELECTORS.dealerPrice).removeClass(CSS_CLASSES.hidden);
        $currentItem.find(SELECTORS.dealerPriceValue).text(parseFloat(data[key].estimated_dealership_price).toFixed(2));
      } else {
        $currentItem.find(SELECTORS.dealerPrice).addClass(CSS_CLASSES.hidden);
      }
      $currentItem.find(SELECTORS.priceLoading).addClass(CSS_CLASSES.hidden);
      $currentItem.find(SELECTORS.price).removeClass(CSS_CLASSES.hidden);
      $currentItem.find(SELECTORS.workItemPriceInline).removeClass(CSS_CLASSES.hidden);
    });
  }

  _handleFetchPricesError() {
    $(SELECTORS.workItemPrice).addClass(CSS_CLASSES.hidden);
  }
}
